import { Injectable } from "@angular/core";
import { IAuthentification, MFA_TYPE } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class AuthApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Authentication", // Theme !
      ["mfa/enable-dashboard", "mfa/disable", "mfa/confirm", "authenticate_dashboard", "authenticate2fa"], // Post route paths
      [], // Get route paths
      ["dashboard/resetAuthCodeOrPassword", "dashboard/mfa/disablePatient"], // Update route paths
      [] // Delete route paths
    );
  }

  public authenticate(email: string, password: string): Observable<IAuthentification> {
    return this.api.post(this.createRoutes[3], {
      login: email,
      password,
    }) as Observable<IAuthentification>;
  }

  public authenticate2FA(token: string, code: string) {
    const body = { token2fa: token, code };
    return this.api.post(this.createRoutes[4], body);
  }

  public getEHealthRedirectUrl(): Observable<string> {
    return this.api.get("free/dashboard/startEHealthAuth") as Observable<string>;
  }

  public authenticateANS(code: string): Observable<IAuthentification> {
    return this.api.get("free/dashboard/authANS", { code: code }) as Observable<IAuthentification>;
  }
  public logoutANS(): Observable<string> {
    return this.api.get("free/dashboard/ANSLogoutRedirect") as Observable<string>;
  }

  public redirectToANS(): Observable<string> {
    return this.api.get("free/dashboard/ANSAuthRedirect") as Observable<string>;
  }

  public resetPassword(patientId: string): Observable<boolean> {
    return this.api.put(this.updateRoutes[0], {
      patientId,
    }) as Observable<boolean>;
  }

  public enable2FA(chosenMfaType: MFA_TYPE): Observable<{ secret: string; qrCodeUrl: string }> {
    const body = { mfaType: chosenMfaType };
    return this.api.post(this.createRoutes[0], body) as Observable<{
      secret: string;
      qrCodeUrl: string;
    }>;
  }

  public disable2FA() {
    return this.api.post(this.createRoutes[1], {});
  }

  public confirm2FA(code: string): Observable<boolean> {
    return this.api.post(this.createRoutes[2], { code }) as Observable<boolean>;
  }

  public disablePatient2FA(patientId: string, reinitPwd?: boolean): Observable<unknown> {
    return this.api.put(this.updateRoutes[1], { patientId, reinitPwd });
  }

  public getCaptcha(login: string): Observable<Blob> {
    return this.api.getBlob("dashboard/captcha", { type: "reset", login });
  }

  public submitCaptcha(type: string, login: string, code: string): Observable<unknown> {
    return this.api.post("dashboard/captcha", { type, login, code });
  }

  public setNewPractitionerPassword(password: string, resetCode: string, login: string): Observable<{ token: string }> {
    return this.api.post("dashboard/newPractitionerPassword", { password, resetCode, login }) as Observable<{ token: string }>;
  }
}
